var ProductCardElement;
/** Cache do JSON de variantes por nó de cartão (ProductCardElement). */
var teamdropProductCardVariantJsonCache = new WeakMap();

/** Comportamento partilhado add-to-cart / PDP (sem theme.product.form). */
window.teamdropProductFormProto = {
  sectionId: "",
  form: null,
  render: function () {
    this.form &&
      ((this.form.querySelector("input[name=id]").disabled = !1),
        this.form.addEventListener("submit", this.submitHandler.bind(this)),
        (this.errorMsgElement = this.form.querySelector(".field-msg")));
  },
  submitHandler: async function (e) {
    e.preventDefault();
    var btn =
      e.submitter ||
      this.form.querySelector('[data-add-to-cart-trigger], .product-form__submit');
    if (!btn) return;

    this.showLoader(btn);
    this.hideErrorMsg();

    try {
      // theme.cart.add() já cuida de: fetch com sections, atualizar counter,
      // injetar HTML do drawer, abrir drawer (ou redirecionar /cart) e disparar cart:added.
      await theme.cart.add(new FormData(this.form));

      // Buy now: ignora o drawer e vai direto pro cart.
      if (btn.classList.contains("buy-now")) {
        window.location.href = "/cart";
      }
    } catch (err) {
      this.handleError(err.message);
    } finally {
      var self = this;
      setTimeout(function () { self.hideLoader(btn); }, 500);
    }
  },
  handleError: function (e = !1) {
    if (!this.errorMsgElement) return;
    var span = this.errorMsgElement.querySelector("span");
    if (span) span.innerHTML = e;
    this.errorMsgElement.classList.remove("u-none");
  },
  hideErrorMsg: function () {
    this.errorMsgElement && this.errorMsgElement.classList.add("u-none");
  },
  showLoader: function (e) {
    theme.utilities.toggleSpinner(e, true);
  },
  hideLoader: function (e) {
    theme.utilities.toggleSpinner(e, false);
  },
  /* Botões de compra do produto da página (formulário, barra fixa); o do compre junto tem o próprio */
  disableBuyButton: function () {
    document.querySelectorAll(".product-form__submit:not(compre-junto *)").forEach((e) => {
      e.setAttribute("disabled", !0);
      let t = e.querySelector("span");
      t && (t.textContent = window.accessibilityStrings.soldOut);
    });
  },
  /* Botão com texto próprio (ex.: "Escolher lentes e comprar" do seletor de lentes) guarda o texto em
     data-available-label e volta para ele ao trocar de variante */
  enableBuyButton: function () {
    document.querySelectorAll(".product-form__submit:not(compre-junto *)").forEach((e) => {
      e.removeAttribute("disabled");
      let t = e.querySelector("span");
      if (!t) return;
      if (e.dataset.availableLabel) t.textContent = e.dataset.availableLabel;
      else if (e.classList.contains("buy-now")) t.textContent = window.accessibilityStrings.buyNow;
      else t.textContent = window.accessibilityStrings.addToCart;
    });
  },
};
var teamdropProductFormProto = window.teamdropProductFormProto;

(theme.product = {
  // <product-tile> é lazy via Web Component; mainPage (zoom) inicializa no fim deste arquivo.
  // Lista "nome: cor" separada por vírgula. A cor pode ser hex ou gradiente/url(...) com várias camadas:
  // um trecho só abre uma cor nova se tiver "nome:" fora de parênteses; senão é camada da cor anterior.
  customSwatchColors: function () {
    if (this._swatchColors) return this._swatchColors;
    let map = {},
      key = null,
      src = window.themeSettings.productColors || "",
      chunks = [],
      depth = 0,
      start = 0;
    for (let i = 0; i < src.length; i++) {
      if (src[i] === "(") depth++;
      else if (src[i] === ")") depth--;
      else if (src[i] === "," && depth === 0) chunks.push(src.slice(start, i)), (start = i + 1);
    }
    chunks.push(src.slice(start));
    chunks.forEach((chunk) => {
      let d = 0,
        colon = -1;
      for (let i = 0; i < chunk.length && colon < 0; i++) {
        if (chunk[i] === "(") d++;
        else if (chunk[i] === ")") d--;
        else if (chunk[i] === ":" && d === 0) colon = i;
      }
      if (colon > 0) {
        key = chunk.slice(0, colon).trim().toLowerCase();
        map[key] = chunk.slice(colon + 1).trim();
      } else if (key && chunk.trim()) {
        map[key] += "," + chunk.trim();
      }
    });
    return (this._swatchColors = map);
  },
  // CSS da amostra para o nome da cor: hex vira --swatch-background-color; gradiente/url vira --swatch-background-image.
  swatchStyle: function (name) {
    let value = name && this.customSwatchColors()[String(name).toLowerCase()];
    if (!value) return "";
    return /\(/.test(value) ? "--swatch-background-image: " + value : "--swatch-background-color: " + value;
  },
});

theme.product.quantityInput = {
    wrapper: null,
    element: null,
    render: function () {
      let self = this;
      if (this.wrapper) {
        Array.from(this.wrapper.getElementsByClassName("product-quantity")).forEach(function (container) {
          Array.from(container.getElementsByTagName("button")).forEach(function (btn) {
            btn.addEventListener("click", self.handleOnClick.bind(self));
          });
        });
      }

      if (this.element) {
        this.element.querySelectorAll("button").forEach(function (btn) {
          btn.addEventListener("click", self.handleOnClick.bind(self));
        });
      }
    },
    handleOnClick: function (event) {
      event.preventDefault();

      let input = event.currentTarget.closest(".product-quantity").querySelector("input");
      if ("minus" === event.currentTarget.name && 1 === parseInt(input.value)) {
        let removeBtn = event.currentTarget.closest(".cart-item")?.querySelector(".js-item-remove");
        if (removeBtn) {
          removeBtn.click();
          return;
        }
      }

      if ("plus" === event.currentTarget.name) input.stepUp();
      else input.stepDown();

      this.toggleButton(event.currentTarget);
      input.dispatchEvent(new Event("change"));
    },
    toggleButton: function (button) {
      var input = button.closest(".product-quantity").querySelector("input");
      let minusBtn = button.closest(".product-quantity").querySelector('button[name="minus"]');
      minusBtn.disabled = parseInt(input.value) === 1;
    },
  };

// add-to-cart Web Component (usa teamdropProductFormProto — não duplica submit).
class AddToCartElement extends EssenceBaseComponent {
  get eagerInit() { return true; }

  init() {
    // product.js carrega antes de cart.js. O submit só usa theme.cart.add no clique,
    // então não dá para abortar aqui — senão o input name=id permanece disabled
    // (product-form.liquid) e o add nativo também falha.
    if (!theme || !theme.utilities) return;

    const form = this.resolveForm();
    if (!form) return;

    if (form.dataset.addToCartBound === "true") return;
    form.dataset.addToCartBound = "true";

    const controller = Object.create(teamdropProductFormProto);
    controller.form = form;
    controller.render();

    this.form = form;
    this.controller = controller;
  }

  destroy() {
    if (this.form && this.form.dataset.addToCartBound === "true") {
      delete this.form.dataset.addToCartBound;
    }
    this.form = null;
    this.controller = null;
  }

  resolveForm() {
    if (this.form) return this.form;

    const formId = this.getAttribute("form-id");
    if (formId) {
      const byId = document.getElementById(formId);
      if (byId && byId.tagName === "FORM") return byId;
    }

    const formSelector = this.getAttribute("form-selector");
    if (formSelector) {
      const bySelector = document.querySelector(formSelector);
      if (bySelector && bySelector.tagName === "FORM") return bySelector;
    }

    const nestedForm = this.querySelector("form");
    if (nestedForm) return nestedForm;

    const nearestForm = this.closest("form");
    if (nearestForm) return nearestForm;

    return null;
  }
}

if (window.customElements && !customElements.get("add-to-cart")) {
  customElements.define("add-to-cart", AddToCartElement);
}
// product-card: lazy via IntersectionObserver (15% do viewport).
ProductCardElement = class ProductCardElement extends EssenceBaseComponent {
    init() {
      ProductCardElement.setupCardRoot(this);
    }

    destroy() {
      this.removeAttribute("card-rendered");
    }

    /**
     * Liga comportamento do cartão (swatches) a qualquer raiz .product-card ou <product-tile>.
     */
    static setupCardRoot(root) {
      if (!root || !theme || !theme.product) return;
      if (root.hasAttribute("card-rendered")) return;

      var swatches = root.querySelector(".product-card__swatches");
      if (swatches) {
        swatches.querySelectorAll('input[type="radio"]').forEach(function (radio) {
          radio.addEventListener("change", function (ev) {
            ProductCardElement.handleVariantRadioChange(ev, root);
          });
          var label = swatches.querySelector(
            'label[for="' + radio.getAttribute("id") + '"]'
          );
          if (label && label.dataset.swatch) {
            var swatchCss = theme.product.swatchStyle(label.dataset.swatch);
            if (swatchCss) label.style.cssText = swatchCss;
          }
        });
      }

      root.setAttribute("card-rendered", "");
    }

    static handleVariantRadioChange(ev, root) {
      ev.preventDefault();
      var input = ev.currentTarget;
      var value = input.value;
      var optIndex = parseInt(input.dataset.optionPosition, 10) - 1;
      var rows = ProductCardElement.getVariantData(root);
      var variant = rows.find(function (row) {
        return row.options[optIndex] === value;
      });
      if (!variant) return;

      var cardRoot = input.closest(".product-card") || root;
      cardRoot.querySelectorAll(".variant-img").forEach(function (wrap) {
        wrap.classList.remove("variant-img--active");
      });
      var thumb = cardRoot.querySelector(
        '[data-variant-image="' + variant.id + '"]'
      );
      if (thumb) {
        var inner = thumb.querySelector(".variant-img");
        if (inner) inner.classList.add("variant-img--active");
      }
    }

    static getVariantData(root) {
      var cached = teamdropProductCardVariantJsonCache.get(root);
      if (cached) return cached;
      var data = teamdropGetProductJson(root);
      var parsed = data && data.variants ? data.variants : [];
      teamdropProductCardVariantJsonCache.set(root, parsed);
      return parsed;
    }
  };

if (window.customElements && !customElements.get("product-tile")) {
  customElements.define("product-tile", ProductCardElement);
}

/**
 * <product-gallery-swiper> — galeria de PDP / featured-product.
 * Em main-product: data-eager (init imediato).
 * Em featured-product: lazy (15% do viewport via EssenceBaseComponent default).
 */
function teamdropGetProductJson(root) {
  // Dados do produto: snippets/product-data.liquid (um <script type="application/json"> por produto)
  var holder = root.closest("[data-product-id]") || root;
  var productId = holder.dataset.productId;
  var script = productId && (root.querySelector('script[data-product-json="' + productId + '"]') || document.querySelector('script[data-product-json="' + productId + '"]'));
  if (!script || !script.textContent) return null;
  try {
    return JSON.parse(script.textContent);
  } catch (e) {
    return null;
  }
}

/**
 * Ponte entre theme.product.variant (updateMedia → slideToLoop) e a galeria
 * <product-gallery-swiper> dentro de `root`. O Swiper é lido na hora da troca de
 * variante, então funciona mesmo com a galeria lazy (featured-product) ainda sem init.
 */
function teamdropGallerySlider(root) {
  var gallery = root && root.querySelector("product-gallery-swiper");
  if (!gallery) return null;
  return {
    slideToLoop: function (index, speed) {
      if (gallery.mainSwiper) gallery.mainSwiper.slideToLoop(index, speed);
    },
  };
}

/** Posição das miniaturas → direção do Swiper delas. */
function thumbDirectionFor(position) {
  return position === "left" || position === "right" ? "vertical" : "horizontal";
}

class ProductGallerySwiper extends EssenceBaseComponent {
  connectedCallback() {
    var mainEl = this.querySelector(".product-media__swiper");
    var thumbsEl = this.querySelector(".product-media__nav-swiper");
    if (mainEl && !mainEl.classList.contains("swiper")) mainEl.classList.add("swiper");
    if (thumbsEl && !thumbsEl.classList.contains("swiper")) thumbsEl.classList.add("swiper");
    super.connectedCallback();
  }

  init() {
    if (typeof Swiper === "undefined") return;

    this.mainEl = this.querySelector(".product-media__swiper");
    if (!this.mainEl) return;

    this.thumbsEl = this.querySelector(".product-media__nav-swiper");

    // Posição das miniaturas por tela (bottom | left | right | none), vinda da section.
    // Esquerda/direita = coluna vertical; embaixo = faixa horizontal; none = escondidas pelo CSS.
    this.thumbsMobile = this.dataset.thumbsMobile;
    this.thumbsDesktop = this.dataset.thumbsDesktop;
    var hasThumbs = !!(
      this.thumbsEl &&
      this.dataset.noThumbs !== "true" &&
      !(this.thumbsMobile === "none" && this.thumbsDesktop === "none")
    );

    var sectionId = this.dataset.sectionId || "";
    var initialSlide = this.computeInitialSlide(sectionId);

    var thumbsModule = false;
    if (hasThumbs) {
      if (!this.thumbsEl.classList.contains("swiper")) this.thumbsEl.classList.add("swiper");

      var applyAnim = function () {
        if (theme && theme.utilities) theme.utilities.applyAnimation();
      };
      var self = this;
      var layoutFor = function (position, gap) {
        var direction = thumbDirectionFor(position);
        return {
          direction: direction,
          slidesPerView: direction === "vertical" ? "auto" : 6,
          spaceBetween: gap,
        };
      };

      this.syncThumbsViewport();

      // Gaps iguais aos do CSS pré-init: --space-3 (8px) no celular, --space-4 (12px) no computador.
      var mobileLayout = layoutFor(this.thumbsMobile, 8);
      this.thumbsSwiper = new Swiper(this.thumbsEl, {
        direction: mobileLayout.direction,
        slidesPerView: mobileLayout.slidesPerView,
        spaceBetween: mobileLayout.spaceBetween,
        watchSlidesProgress: true,
        watchOverflow: true,
        mousewheel: { forceToAxis: true, releaseOnEdges: true },
        breakpoints: {
          0: mobileLayout,
          768: layoutFor(this.thumbsDesktop, 12),
        },
        on: {
          afterInit: applyAnim,
          loopFix: applyAnim,
          breakpoint: function () {
            window.requestAnimationFrame(function () {
              self.syncThumbsViewport();
            });
          },
        },
      });
      thumbsModule = { swiper: this.thumbsSwiper };
    }

    if (!this.mainEl.classList.contains("swiper")) this.mainEl.classList.add("swiper");

    var paginationEl = this.mainEl.querySelector(".product-media-pagination");
    var nextMain = this.mainEl.querySelector(".swiper-nav-next");
    var prevMain = this.mainEl.querySelector(".swiper-nav-prev");

    var applyAnimMain = function () {
      if (theme && theme.utilities) theme.utilities.applyAnimation();
    };

    var mainOpts = {
      spaceBetween: 10,
      loop: true,
      initialSlide: initialSlide,
      navigation: nextMain && prevMain ? { nextEl: nextMain, prevEl: prevMain } : false,
      on: { afterInit: applyAnimMain, loopFix: applyAnimMain },
      // Rótulos das setas vêm do snippet slider-arrows (traduzidos); sem isso o Swiper põe os dele em inglês.
      a11y: nextMain && prevMain ? {
        prevSlideMessage: prevMain.getAttribute("aria-label"),
        nextSlideMessage: nextMain.getAttribute("aria-label"),
      } : {},
    };

    if (paginationEl) {
      mainOpts.pagination = { el: paginationEl, type: "fraction" };
    }
    if (thumbsModule) mainOpts.thumbs = thumbsModule;

    this.mainSwiper = new Swiper(this.mainEl, mainOpts);
    this.bindThumbsViewport();
  }

  /** Miniaturas em coluna acompanham a altura da imagem principal; em faixa, altura livre. */
  syncThumbsViewport() {
    if (!this.thumbsEl || !this.mainEl) return;
    var isDesktop = window.matchMedia("(min-width: 768px)").matches;
    var position = isDesktop ? this.thumbsDesktop : this.thumbsMobile;
    if (thumbDirectionFor(position) !== "vertical") {
      this.thumbsEl.style.height = "";
      return;
    }
    var h = this.mainEl.getBoundingClientRect().height;
    if (!(h > 0)) return;
    this.thumbsEl.style.height = Math.round(h) + "px";
    if (this.thumbsSwiper && typeof this.thumbsSwiper.update === "function") {
      this.thumbsSwiper.update();
    }
  }

  bindThumbsViewport() {
    this.syncThumbsViewport();
    if (this.__tdThumbsRo || typeof ResizeObserver === "undefined" || !this.mainEl) return;
    var self = this;
    this.__tdThumbsRo = new ResizeObserver(function () {
      self.syncThumbsViewport();
    });
    this.__tdThumbsRo.observe(this.mainEl);
  }

  computeInitialSlide(sectionId) {
    if (!window.location.search.includes("?variant=")) return 0;
    var product = teamdropGetProductJson(this);
    var variant = product && product.selected_or_first_available_variant;
    if (!variant || !variant.featured_media) return 0;
    var mid = variant.featured_media.id;
    var slide = this.mainEl.querySelector(
      '[data-media-id="' + sectionId + "-" + mid + '"]'
    );
    if (!slide || slide.dataset.index === undefined) return 0;
    return parseInt(slide.dataset.index, 10) || 0;
  }

  destroy() {
    if (this.__tdThumbsRo) {
      this.__tdThumbsRo.disconnect();
      this.__tdThumbsRo = null;
    }
    if (this.thumbsEl) this.thumbsEl.style.height = "";
    if (this.mainSwiper && typeof this.mainSwiper.destroy === "function") {
      this.mainSwiper.destroy(true, true);
    }
    this.mainSwiper = null;
    if (this.thumbsSwiper && typeof this.thumbsSwiper.destroy === "function") {
      this.thumbsSwiper.destroy(true, true);
    }
    this.thumbsSwiper = null;
  }
}

if (window.customElements && !customElements.get("product-gallery-swiper")) {
  customElements.define("product-gallery-swiper", ProductGallerySwiper);
}

theme.photoSwipe =
  theme.photoSwipe ||
  {
    scriptPromise: null,

    init: function (container) {
      if (!container || container.dataset.enabledZoom !== "true") return;

      var zoomButton = container.querySelector("[data-pswp-trigger]");
      if (!zoomButton || zoomButton.dataset.pswpBound === "true") return;

      zoomButton.dataset.pswpBound = "true";
      zoomButton.addEventListener("click", this.handleTriggerClick.bind(this, container));
    },

    handleTriggerClick: async function (container, event) {
      event.preventDefault();

      var trigger = event.currentTarget;
      var items = this.getItems(container);
      if (!items.length) return;

      await this.loadScript(trigger.getAttribute("data-pswp"));
      if (typeof window.PhotoSwipe !== "function") return;

      var pswp = new window.PhotoSwipe({
        dataSource: items,
        index: this.getInitialIndex(container, items.length),
        loop: items.length > 1,
        showHideAnimationType: "zoom",
        bgOpacity: 0.9,
      });

      pswp.init();
    },

    loadScript: function (src) {
      if (typeof window.PhotoSwipe === "function") return Promise.resolve();
      if (this.scriptPromise) return this.scriptPromise;
      if (!src) return Promise.resolve();

      this.scriptPromise = new Promise(function (resolve, reject) {
        var existing = document.querySelector('script[data-photoswipe-script="true"]');
        if (existing) {
          existing.addEventListener("load", resolve, { once: true });
          existing.addEventListener("error", reject, { once: true });
          return;
        }

        var script = document.createElement("script");
        script.src = src;
        script.defer = true;
        script.dataset.photoswipeScript = "true";
        script.addEventListener("load", resolve, { once: true });
        script.addEventListener("error", reject, { once: true });
        document.head.appendChild(script);
      });

      return this.scriptPromise;
    },

    getItems: function (container) {
      var galleryRoot =
        container.querySelector(".product-media__swiper .swiper-wrapper") || container;

      return Array.from(galleryRoot.querySelectorAll(".pr-image"))
        .map(function (img) {
          var src = img.currentSrc || img.src;
          if (!src) return null;

          var width =
            img.naturalWidth || parseInt(img.getAttribute("width"), 10) || img.clientWidth || 1600;
          var height =
            img.naturalHeight || parseInt(img.getAttribute("height"), 10) || img.clientHeight || width;

          return {
            src: src,
            width: width,
            height: height,
            alt: img.getAttribute("alt") || "",
          };
        })
        .filter(Boolean);
    },

    getInitialIndex: function (container, totalItems) {
      var gallery = container.querySelector("product-gallery-swiper");
      var swiper = gallery && gallery.mainSwiper;
      if (!swiper || typeof swiper.realIndex !== "number") return 0;
      if (swiper.realIndex < 0 || swiper.realIndex >= totalItems) return 0;
      return swiper.realIndex;
    },
  };

theme.product.variant = {
    productVariant: null,
    imageSlider: null,
    form: null,
    selectedVariant: null,
    selectedOptions: null,
    availableVariant: null,
    variantData: null,
    updateUrlOnVariantChanged: !1,
    sections: null,
    render: function () {
      if (this.productVariant) {
        let e = this;
        (this.productUrl = this.productVariant.dataset.url),
          (this.sectionId = this.productVariant.dataset.section),
          (this.optionStyle = this.productVariant.dataset.style),
          (this.firstOptionContainer = this.productVariant.querySelector(
            '.product-variant__option[data-option-index="1"]'
          )),
          (this.optionContainer = this.productVariant.querySelectorAll(
            ".product-variant__option"
          )),
          this.firstOptionContainer &&
          ("swatches" === this.optionStyle
            ? ((this.options = this.productVariant.querySelectorAll(
              'input[type="radio"]'
            )),
              this.firstOptionContainer
                .querySelectorAll('input[type="radio"]')
                .forEach((t) => {
                  t.addEventListener(
                    "change",
                    e.handleFirstOptionChange.bind(e)
                  );
                  let i = e.productVariant.querySelector(
                    `label[for="${t.getAttribute("id")}"]`
                  );
                  i.classList.contains("label--tag") ||
                    ((t = theme.product.swatchStyle(i.dataset.swatch)) &&
                      (i.style.cssText = t));
                }),
              this.optionContainer.forEach((t) => {
                t.querySelectorAll('input[type="radio"]').forEach((t) => {
                  t.addEventListener("change", e.handleVariantChange.bind(e));
                });
              }))
            : ((this.options =
              this.productVariant.querySelectorAll("select")),
              this.firstOptionContainer
                .querySelector("select")
                .addEventListener(
                  "change",
                  e.handleFirstOptionChange.bind(e)
                ),
              this.options.forEach((t) => {
                t.addEventListener("change", e.handleVariantChange.bind(e));
              })),
            (this.selectedOptions = this.getSelectedOptions()),
            (this.selectedVariant = this.getSelectedVariantData(
              this.selectedOptions
            )),
            (this.availableVariant =
              "swatches" === this.optionStyle
                ? this.getAvailableVariant(
                  this.firstOptionContainer.querySelector("input:checked")
                )
                : this.getAvailableVariant(
                  this.firstOptionContainer.querySelector("select")
                )),
            this.setAvailableOption(),
            this.getAvailableFirstOptions());
      }
    },
    handleFirstOptionChange: function (e) {
      (this.availableVariant = this.getAvailableVariant(e.target)),
        this.setAvailableOption();
    },
    handleVariantChange: function (e) {
      if (
        ((this.selectedOptions = this.getSelectedOptions()),
          (this.selectedVariant = this.getSelectedVariantData(
            this.selectedOptions
          )),
          this.updateMedia(),
          this.selectedVariant && this.selectedVariant.available
            ? (this.updateVariantInput(),
              this.updateUrlOnVariantChanged && this.updateURL(),
              this.renderProductInfo(),
              this.form && this.form.enableBuyButton(),
              this.updateAllProductVariantElement(
                e.target.closest(
                  `.product-variant[data-section="${this.sectionId}"]`
                )
              ))
            : this.form && this.form.disableBuyButton(),
          "swatches" === this.optionStyle)
      ) {
        let t = e.target;
        t
          .closest(".product-variant__option")
          .querySelector(".selected-option-variant").innerHTML = t.value;
      }
    },
    getAvailableVariant: function (e) {
      return this.getVariantData().filter((t) => t.option1 === e.value);
    },
    setAvailableOption: function () {
      let e = this.availableVariant;
      "swatches" === this.optionStyle
        ? Array.from(this.optionContainer)
          .slice(1)
          .forEach((t, i) => {
            t.querySelectorAll('input[type="radio"]').forEach((t) => {
              0 ===
                e.filter((e) => e.options[i + 1] === t.value && e.available)
                  .length
                ? t.classList.add("product-variant__input--unavailable")
                : t.classList.remove("product-variant__input--unavailable");
            });
          })
        : Array.from(this.options)
          .slice(1)
          .forEach((t, i) => {
            t.querySelectorAll("option").forEach((t) => {
              0 ===
                e.filter((e) => e.options[i + 1] === t.value && e.available)
                  .length
                ? t.setAttribute("disabled", !0)
                : t.removeAttribute("disabled");
            });
          });
    },
    getSelectedOptions: function () {
      return "swatches" === this.optionStyle
        ? Array.from(this.options)
          .filter((e) => e.checked)
          .map((e) => e.value)
        : Array.from(this.productVariant.querySelectorAll("select")).map(
          (e) => e.value
        );
    },
    getSelectedVariantData: function (e) {
      return this.getVariantData().find(
        (t) => !t.options.map((t, i) => e[i] === t).includes(!1)
      );
    },
    getAvailableFirstOptions: function () {
      1 < this.optionContainer.length ||
        (1 === this.optionContainer.length &&
          ("swatches" === this.optionStyle
            ? this.optionContainer[0]
              .querySelectorAll('input[type="radio"]')
              .forEach((e) => {
                this.getVariantData().find(
                  (t) => t.option1 === e.value && t.available
                )
                  ? e.classList.remove("product-variant__input--unavailable")
                  : e.classList.add("product-variant__input--unavailable");
              })
            : this.optionContainer[0]
              .querySelectorAll("option")
              .forEach((e) => {
                this.getVariantData().find(
                  (t) => t.option1 === e.value && t.available
                )
                  ? e.removeAttribute("disabled")
                  : e.setAttribute("disabled", !0);
              })));
    },
    updateURL: function () {
      this.selectedVariant &&
        !1 !== this.productVariant.dataset.updateUrl &&
        window.history.replaceState(
          {},
          "",
          this.productUrl + "?variant=" + this.selectedVariant.id
        );
    },
    updateMedia: function () {
      var e;
      this.selectedVariant &&
        this.selectedVariant.featured_media &&
        (e = document.querySelector(
          `[data-media-id="${this.sectionId}-${this.selectedVariant.featured_media.id}"]`
        )) &&
        this.imageSlider &&
        ((e = parseInt(e.dataset.index)),
          this.imageSlider.slideToLoop(parseInt(e), 600));
    },
    updateVariantInput: function () {
      let e = this;
      document
        .querySelectorAll(
          "#product-form-" + this.sectionId + ", #product-form-sticky-" + this.sectionId
        )
        .forEach((t) => {
          let i = t.querySelector('input[name="id"]');
          if (!i) return;
          (i.value = e.selectedVariant.id),
            i.dispatchEvent(new Event("change", { bubbles: !0 }));
        });
    },
    renderStickyFormVariant: function () {
      (this.productUrl = this.productVariant.dataset.url),
        (this.productId = this.productVariant.dataset.productId),
        (this.sectionId = this.productVariant.dataset.section);
      let e = this.productVariant.querySelector(".product-variant__select"),
        t = this.getVariantData();
      e.querySelectorAll("option").forEach((e) => {
        t.find((t) => t.id === parseInt(e.value) && t.available)
          ? e.removeAttribute("disabled")
          : e.setAttribute("disabled", !0);
      }),
        e.addEventListener(
          "change",
          this.handleStickyFormVariantChange.bind(this)
        );
    },
    handleStickyFormVariantChange: function (e) {
      let t = parseInt(e.target.value);
      (this.selectedVariant = this.getVariantData().find((e) => e.id === t)),
        this.selectedVariant && this.selectedVariant.available
          ? (this.updateVariantInput(),
            this.updateUrlOnVariantChanged && this.updateURL(),
            this.renderProductInfo(),
            this.form && this.form.enableBuyButton(),
            this.updateAllProductVariantElement(
              e.target.closest(
                `.product-variant[data-section="${this.sectionId}"]`
              )
            ))
          : this.form && this.form.disableBuyButton();
    },
    updateAllProductVariantElement: function (e) {
      let t = document.querySelectorAll(
        `.product-variant[data-section="${this.sectionId}"]`
      ),
        i = this;
      t.forEach((t) => {
        t != e &&
          ("swatches" === t.dataset.style
            ? t.querySelectorAll(".product-variant__inputs").forEach((e, t) => {
              e.querySelectorAll('input[type="radio"]').forEach((e) => {
                e.value === i.selectedVariant.options[t]
                  ? (e.checked = !0)
                  : (e.checked = !1);
              });
            })
            : t.querySelectorAll("select").forEach((e, t) => {
              Array.from(e.querySelectorAll("option"))
                .map((e) => parseInt(e.value))
                .includes(i.selectedVariant.id)
                ? (e.value = i.selectedVariant.id)
                : (e.value = i.selectedVariant.options[t]);
            }));
      });
    },
    renderProductInfo: function () {
      let e = this;
      var t = this.sections.map((e) => e.sectionId).join(",");
      fetch(
        `${this.productUrl}?variant=${this.selectedVariant.id}&sections=` + t
      )
        .then((e) => e.json())
        .then((t) => {
          e.sections.forEach((e) => {
            let i = new DOMParser().parseFromString(
              t[e.sectionId],
              "text/html"
            );
            e.selectors.forEach((e) => {
              let t = document.querySelector(e),
                n = i.querySelector(e);
              t && n && (t.innerHTML = n.innerHTML);
            });
          });
        });
    },
    getVariantData: function () {
      if (!this.variantData) {
        var data = teamdropGetProductJson(this.productVariant);
        this.variantData = data && data.variants ? data.variants : [];
      }
      return this.variantData;
    },
  };

theme.product.mainPage =
  theme.product.mainPage ||
  {
    render: function (root) {
      var mainRoot =
        root ||
        document.querySelector(".main-product .product-detail") ||
        document.querySelector(".featured-product .product-detail");
      if (!mainRoot) return;

      if (theme.photoSwipe) theme.photoSwipe.init(mainRoot);
      if (mainRoot.dataset.pdpBound === "true") return;
      mainRoot.dataset.pdpBound = "true";

      var imageSlider = teamdropGallerySlider(mainRoot);

      var formEl = mainRoot.querySelector(".product-form");
      var formCtl = null;
      if (formEl) {
        formCtl = Object.create(window.teamdropProductFormProto || teamdropProductFormProto);
        formCtl.form = formEl;
      }

      var sectionId = mainRoot.dataset.sectionId;
      var selectors = [
        "#price-" + sectionId,
        "#stock-" + sectionId,
      ];
      var sticky = document.querySelector(".product-sticky");
      if (sticky) selectors.push(".product-sticky .js-contents");

      var variantRoot = mainRoot.querySelector(".product-variant");
      if (theme.product.variant && variantRoot) {
        var variantCtl = Object.create(theme.product.variant);
        variantCtl.productVariant = variantRoot;
        variantCtl.imageSlider = imageSlider;
        variantCtl.form = formCtl;
        variantCtl.updateUrlOnVariantChanged = !!mainRoot.closest(".main-product");
        variantCtl.sections = [{ sectionId: sectionId, selectors: selectors }];
        variantCtl.render();
      }

      var qtyWrap = mainRoot.querySelector(".product-detail__buy-buttons");
      if (qtyWrap && theme.product.quantityInput) {
        var qtyCtl = Object.create(theme.product.quantityInput);
        qtyCtl.wrapper = qtyWrap;
        qtyCtl.render();
      }

      if (!sticky) return;

      var stickyForm = sticky.querySelector(".product-form");
      var stickyFormCtl = null;
      if (stickyForm && window.teamdropProductFormProto) {
        stickyFormCtl = Object.create(window.teamdropProductFormProto);
        stickyFormCtl.form = stickyForm;
        stickyFormCtl.handleError = function (msg) {
          if (theme.notification && theme.notification.error) {
            theme.notification.error(
              window.cartStrings.cannotUpdateCart,
              msg || ""
            );
          }
        };
        if (stickyForm.dataset.addToCartBound !== "true") {
          stickyForm.dataset.addToCartBound = "true";
          stickyFormCtl.render();
        }
      }

      var stickyQty = sticky.querySelector(".product-quantity");
      if (stickyQty && theme.product.quantityInput) {
        var stickyQtyCtl = Object.create(theme.product.quantityInput);
        stickyQtyCtl.element = stickyQty;
        stickyQtyCtl.render();
      }

      var stickyVariant = sticky.querySelector(".product-variant");
      if (theme.product.variant && stickyVariant && stickyFormCtl) {
        var stickyVariantCtl = Object.create(theme.product.variant);
        stickyVariantCtl.productVariant = stickyVariant;
        stickyVariantCtl.sections = [{ sectionId: sectionId, selectors: selectors }];
        stickyVariantCtl.form = stickyFormCtl;
        stickyVariantCtl.updateUrlOnVariantChanged = true;
        stickyVariantCtl.renderStickyFormVariant();
      }
    },
  };

function teamdropBootstrapProductPdp() {
  if (!theme || !theme.product || !theme.product.mainPage) return;
  theme.product.mainPage.render();
}

if (document.readyState === "complete") {
  teamdropBootstrapProductPdp();
} else {
  document.addEventListener("DOMContentLoaded", teamdropBootstrapProductPdp);
}
